module.exports = __webpack_public_path__ + "img/free.a63c57e4.jpg";